/*eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  Carousel,
  Slide
} from 'vue-carousel';
import {
  mapGetters,
  mapState
} from 'vuex';

import axios from 'axios';
import {
  bus
} from '@/main';
import courseSectionDescription from '@/components/courseSectionDescription/index';
import newCourseListSmall from '@/components/newCourseListSmall/index'
import root from '@/_helpers/roots';

export default {
  name: 'interview-course-details',
  components: {
    Carousel,
    Slide,
    'newcourse-list-small': newCourseListSmall,
    'course-section-descirption': courseSectionDescription
  },
  props: [],
  data() {
    return {
      toggleText: 'Expand All',
      courseDetail: {},
      accordionVal: 0,
      assignmentVal: '',
      showTab: -1,
      maxLength: 300,
      orginalText: '',
      showReadMore: false,
      descriptionTextLength: 200,
      topicDescriptionText: '',
      topicReadMore: false,
      loader: true,
      courseID: '',
      showModal: false,
      perPage: [],
      courseQuiz: [],
      coursePoints: [],
      nextStepPoints: "",
      author_names: [],
      selectedNoteId: "",
      noteAdd: false,
      nodeEdit: false,
      deleteModal: false,
      notefileAdd: false,
      notefileEdit: false,
      selectedNoteFileId: '',
      deleteFileModal: false,
      subscription_alert_popup: false,
      userSubscription: '',
      active_subscription:Boolean,
      course_producer: '',
      author_details_length: '',
      pdfViewer: false,
      viewerLoader: false,
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
      url: '',
      imgViewer: false,
      pdfName: '',
      accessedViewerImg: '',
      accessedOtherFile: "",
      accessedCodeSnippetedData: "",
      interviewSectionDetails: {},
      subscription_alert_popup: false,
      invSectionDetails: false,
      invSectionDetailsName:'',
    }
  },
  computed: {
    ...mapGetters([
      'getProfileInfo',
    ]),
  },
  mounted() {
    bus.$on('HideAddNewNotePopup', (data) => {
      this.noteAdd = data.status;
      if (data.reload) {
        this.getCourseNotes();
      }
    });
    bus.$on('HideEditNotePopup', (data) => {
      this.nodeEdit = data.status;
      if (data.reload) {
        this.getCourseNotes();
      }
    });
    bus.$on('HideAddNoteFilePopup', (data) => {
      this.notefileAdd = data.status;
      if (data.reload) {
        this.getCourseNotes();
      }
    });
    bus.$on('HideEditNoteFilePopup', (data) => {
      this.notefileEdit = data.status;
      if (data.reload) {
        this.getCourseNotes();
      }
    });
    this.getUserSubscription()
  },
  methods: {
    getUserSubscription() {
      this.$store.dispatch('getProfile').then((res) => {
        this.active_subscription = res.data.data.has_active_subscription
        console.log(this.active_subscription)
        if (this.active_subscription == true){
          this.$store.dispatch('getSingleCourseDetail', {
            courseid: this.$route.params.courseid
          }).then((res) => {
            this.courseDetail = res.data.data
            let producer_details = res.data.data.authors
            this.course_producer = producer_details.filter(producer => producer.is_producer == true);
            let authors_details = res.data.data.authors
            this.author_details_length = authors_details.filter(authors => authors.is_producer == false);
            setTimeout(() => {
              if (this.perPage && this.perPage == 0)
                this.perPage = [
                  [320, 1],
                  [768, (this.courseDetail.detail_tabs.length >= 2 ? 2 : (this.courseDetail.detail_tabs.length + 1))],
                  [991, (this.courseDetail.detail_tabs.length >= 4 ? 4 : (this.courseDetail.detail_tabs.length + 1))]
                ];
              $('.courseloader').hide();
            }, 0);
            $('.courseloader').hide();
          }).catch((err) => {
            $('.courseloader').hide();
          })
        }else{
          this.$store.dispatch('getInterviewCourseDetails', {
          id: this.$route.params.courseid  }).then((res) => {
          this.courseDetail = res.data.data
          let producer_details = res.data.data.authors
          this.course_producer = producer_details.filter(producer => producer.is_producer == true);
          let authors_details = res.data.data.authors
          this.author_details_length = authors_details.filter(authors => authors.is_producer == false);
          setTimeout(() => {
            if (this.perPage && this.perPage == 0)
              this.perPage = [
                [320, 1],
                [768, (this.courseDetail.detail_tabs.length >= 2 ? 2 : (this.courseDetail.detail_tabs.length + 1))],
                [991, (this.courseDetail.detail_tabs.length >= 4 ? 4 : (this.courseDetail.detail_tabs.length + 1))]
              ];
            $('.courseloader').hide();
          }, 0);
          $('.courseloader').hide();
        }).catch((err) => {
          $('.courseloader').hide();
        })
        }
      }).catch((err) => { });
    },
    showAuthorCread(id) {
      var courseSubContent = '#courseSubContent' + id;
      var courseFullContent = '#courseFullContent' + id
      $(courseSubContent).addClass('d-none');
      $(courseFullContent).removeClass('d-none');
    },
    showAccordion(id, index) {
      var couseContent = '#courseContent' + id;
      var courseTitle = '#coursetitle' + id
      $(couseContent).toggleClass('show');
      $(courseTitle).toggleClass('active');
      let totalOpenBlock = $('.accordion-content.show').length;
      if (totalOpenBlock > 0) {
        this.toggleText = 'Collapse All';
      } else {
        this.toggleText = 'Expand All';
      }
      $('.langauge_code_tabs .nav-item:first-child .nav-link').addClass('active');
      $('.langauge_code_tabs .tab-content .tab-pane:first-child').addClass('active');
      if($('.langauge_code_tabs .nav-item .nav-link').hasClass('has-attachment')){
        document.querySelector('.langauge_code_tabs .nav-item:first-child .nav-link').click();
      }
      $('.section_topic_details:empty').parent().addClass("d-none")
      // if (this.active_subscription == false) {
      //   if (index < 5) {
      //     this.renderMathJax()
      //     var couseContent = '#courseContent' + id;
      //     var courseTitle = '#coursetitle' + id
      //     $(couseContent).toggleClass('show');
      //     $(courseTitle).toggleClass('active');
      //     let totalOpenBlock = $('.accordion-content.show').length;
      //     if (totalOpenBlock > 0) {
      //       this.toggleText = 'Collapse All';
      //     } else {
      //       this.toggleText = 'Expand All';
      //     }
      //     $('.langauge_code_tabs .nav-item:first-child .nav-link').addClass('active');
      //     $('.langauge_code_tabs .tab-content .tab-pane:first-child').addClass('active');
    
      //     if($('.langauge_code_tabs .nav-item .nav-link').hasClass('has-attachment')){
      //       document.querySelector('.langauge_code_tabs .nav-item:first-child .nav-link').click();
      //     }
      //   } else {
      //     this.subscription_alert_popup = true
      //   }
      // }else {
      //   var couseContent = '#courseContent' + id;
      //   var courseTitle = '#coursetitle' + id
      //   $(couseContent).toggleClass('show');
      //   $(courseTitle).toggleClass('active');
      //   let totalOpenBlock = $('.accordion-content.show').length;
      //   if (totalOpenBlock > 0) {
      //     this.toggleText = 'Collapse All';
      //   } else {
      //     this.toggleText = 'Expand All';
      //   }
      //   $('.langauge_code_tabs .nav-item:first-child .nav-link').addClass('active');
      //   $('.langauge_code_tabs .tab-content .tab-pane:first-child').addClass('active');
  
      //   if($('.langauge_code_tabs .nav-item .nav-link').hasClass('has-attachment')){
      //     document.querySelector('.langauge_code_tabs .nav-item:first-child .nav-link').click();
      //   }
      // }
  },
  hideSubscModal() {
    this.subscription_alert_popup = false
  },
  toogleCollaspe() {
    if (this.toggleText == 'Expand All') {
      $('.accordion-title').addClass('active');
      $('.accordion-content').addClass('show');
      this.toggleText = 'Collapse All';
      if ($('.langauge_code_tabs .nav-item .nav-link').hasClass('has-attachment')) {
        document.querySelector('.langauge_code_tabs .nav-item:first-child .nav-link').click();
      }
    } else {
      $('.accordion-title').removeClass('active');
      $('.accordion-content').removeClass('show');
      this.toggleText = 'Expand All';
    }
  },
  renderMathJax() {
    setTimeout(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log('done'));
      }
    }, 100)
  },
  enrollcourse(id) {
    let data = {
      course: id
    }
    this.$store.dispatch('setEnrollNewCourse', data)
      .then((res) => {
        this.getUserSubscription()
        toast.success(res.data.msg);
      })
      .catch((err) => { })
  },
  QuizDetails(){
    this.getCourseQuiz()
  },
  getCourseQuiz() {
    $('.courseloader').show();
    let quizListUrlLink = root.quizListUrlLink.link + '?course=' + this.$route.params.courseid;
    axios.get(quizListUrlLink).then(response => {
      if (response.status === 200) {
        this.courseQuiz = response.data.data.results;
        if (window.location.hash) {
          if (window.location.hash == '#Quizzes') {
            this.showtabDetails('-3');
          }
        }
        $('.courseloader').hide();
      }
    }).catch(err => {
      $('.courseloader').hide();
    })
  },
  showtabDetails(id) {
    this.showTab = id;
    if (id == '-3') {
      window.location.hash = 'Quizzes';
    } else {
      history.replaceState(null, null, ' ');
    }
  },
  getCourseNotes: function() {
    $('.courseloader').show();
    let notesListLink = root.notesListingLink.link + '?course=' + this.$route.params.courseid;
    axios.get(notesListLink).then(response => {
      if (response.status === 200) {
        this.coursePoints = response.data.data.results;
        if (response.data.data.next != null) {
          this.nextStepPoints = response.data.data.next;
        }
        $('.courseloader').hide();
      }
    }).catch(err => {
      $('.courseloader').hide();
    })
  },
  boxesCollaspe(){
    $('.user-dashboard').toggleClass('actvCollaspe')
    $('.boxesCollaspeActv').toggleClass('actvCollaspe')
  },
  showMoreQueAlert(){
    this.subscription_alert_popup = true
  },
  LessAuthorCread(id){
    var courseSubContent = '#courseSubContent' + id;
    var courseFullContent = '#courseFullContent' + id
    $(courseSubContent).removeClass('d-none');
    $(courseFullContent).addClass('d-none');
  },
},
watch: {
},
beforeRouteLeave: function (to, from, next) {
  $('.user-dashboard').removeClass('actvCollaspe');
  $('body').removeClass('sectionDetailsHttpsLoader');
  $('.boxesCollaspeActv').removeClass('actvCollaspe');
  next();
},
}